import { gql } from "@apollo/client";

export default gql`
  query getProfileOverviewQuery($userId: Int!) {
    user(userId: $userId) {
      id
      name
      firstName
      email
      avatar
      timezone
      email
      lastSeenStr
      isInCurrentUserReportingTree
      teamsList {
        id
        title
      }
      managersList {
        id
        name
        avatar
      }
      directReports {
        edges {
          node {
            id
            name
            avatar
          }
        }
      }
      currentRoles {
        id
        title
      }
    }
  }
`;
